export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '学员账号',
    field: 'userName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '学员姓名',
    field: 'fullName'
  },
  {
    headerName: '账号状态',
    field: 'accountState'
  },
  {
    headerName: '上级组织',
    field: 'leadName'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '省份',
    field: 'province'
  },
  {
    headerName: '岗位',
    field: 'positionName'
  },
  {
    headerName: '任职状态',
    field: 'jobState'
  },
  {
    headerName: '业务状态',
    field: 'bizState'
  },
  {
    headerName: '业务名称',
    field: 'bizName'
  },
  {
    headerName: '业务类型',
    field: 'type'
  },
  {
    headerName: '关联业务名称',
    field: 'bizRelationName'
  },
  {
    headerName: '是否主岗',
    field: 'userIdentityType'
  },
  {
    headerName: '分数',
    field: 'score'
  },
  {
    headerName: '结果',
    field: 'pass'
  },
  {
    headerName: '开始时间',
    field: 'startDate'
  },
  {
    headerName: '结束时间',
    field: 'endDate'
  },
]